import React, { useState, useEffect, MouseEvent } from "react";
import { Element } from "@craftjs/core";
import { Container } from "../../components/user/Container";
import { Image } from "../../components/user/Image";

export const HeaderSection = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [hoveredItem, setHoveredItem] = useState<number | null>(null);

  // Handle window resize for responsive behavior
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
      if (window.innerWidth >= 768) {
        setMenuOpen(false); // Close menu when switching to desktop view
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent | any) => {
      // Instead of using ref, check if the click target has a specific data attribute
      const isClickInsideMenu = (event.target as Element).closest(
        '[data-menu-container="true"]'
      );
      if (!isClickInsideMenu && menuOpen) {
        setMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [menuOpen]);

  // Toggle menu function for the burger button
  const handleMenuToggle = (e: MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    setMenuOpen(!menuOpen);
  };

  // Navigation items for the menu
  const navItems = [
    { name: "Home", link: "#" },
    { name: "About", link: "#" },
    { name: "Services", link: "#" },
    { name: "Contact", link: "#" },
  ];

  return (
    <Element
      id="header_section_container"
      canvas
      is={Container}
      background="#1a1a2e"
      height="80px"
      className="header-section"
      padding="0 20px"
      margin="0"
      borderRadius={0}
      width="100%"
      flexDirection="row"
      alignItems="center"
      justifyContent="space-between"
    >
      <Image
        src="https://thegamingclub-lt.com/os-ui/static/lt-thegamingclub-msisdn-cmp-nid/files/8f190950d77d3eca4a95..svg"
        width="150px"
        height="auto"
        margin="0"
        padding="0"
        borderRadius={0}
      />

      <div data-menu-container="true" style={{ position: "relative" }}>
        {/* Burger Menu Button */}
        <div
          style={{
            cursor: "pointer",
            padding: "8px",
            zIndex: 100,
          }}
          onClick={handleMenuToggle}
          data-menu-container="true"
        >
          <div
            style={{
              width: "24px",
              height: "2px",
              backgroundColor: "#ffffff",
              margin: "5px 0",
              transition: "all 0.3s ease",
              transform: menuOpen
                ? "rotate(45deg) translate(5px, 5px)"
                : "none",
            }}
            data-menu-container="true"
          ></div>
          <div
            style={{
              width: "24px",
              height: "2px",
              backgroundColor: "#ffffff",
              margin: "5px 0",
              transition: "all 0.3s ease",
              opacity: menuOpen ? 0 : 1,
            }}
            data-menu-container="true"
          ></div>
          <div
            style={{
              width: "24px",
              height: "2px",
              backgroundColor: "#ffffff",
              margin: "5px 0",
              transition: "all 0.3s ease",
              transform: menuOpen
                ? "rotate(-45deg) translate(5px, -5px)"
                : "none",
            }}
            data-menu-container="true"
          ></div>
        </div>

        {/* Dropdown Menu */}
        {menuOpen && (
          <div
            data-menu-container="true"
            style={{
              position: "absolute",
              top: "100%",
              right: 0,
              backgroundColor: "#1a1a2e",
              border: "1px solid #333",
              borderRadius: "4px",
              padding: "10px 0",
              width: "200px",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
              zIndex: 99,
              marginTop: "10px",
            }}
          >
            {navItems.map((item, index) => (
              <a
                key={index}
                href={item.link}
                data-menu-container="true"
                style={{
                  display: "block",
                  padding: "10px 20px",
                  color: "#fff",
                  textDecoration: "none",
                  fontSize: "16px",
                  transition: "background-color 0.3s ease",
                  backgroundColor:
                    hoveredItem === index ? "#333" : "transparent",
                }}
                onClick={(e) => {
                  // Prevent default behavior if you want to handle navigation with JavaScript
                  // e.preventDefault();
                  setMenuOpen(false);
                }}
                onMouseEnter={() => setHoveredItem(index)}
                onMouseLeave={() => setHoveredItem(null)}
              >
                {item.name}
              </a>
            ))}
          </div>
        )}
      </div>
    </Element>
  );
};
